export const GuideKey = {
  one: 'merchant_delivery',
  two: 'new_merchant_delivery_order'
}
